/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  // rootUrl: string = 'https://virtserver.swaggerhub.com/playstate/SPAIA/1.0.0';
  rootUrl: string = environment.apiUrl;
  // rootUrl: string = 'https://api.spaia.co.za';
  // rootUrl: string = 'https://api.spaia.earth';
}

/**
 * Parameters for `ApiModule.forRoot()`
 */
export interface ApiConfigurationParams {
  rootUrl?: string;
}
